import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import { Container, InputBase } from "@mui/material";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { alpha, styled, useTheme } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as React from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";

import logo from "../assets/Images/LogoB.png";
import BasicPopover from "../components/common-components/BasicPopover";
import { DownArrowIconBlue } from "../assets/Icon/ArrowIcon";
import {
  AgentsIcon,
  AgentsIconBlue,
  BillingIcon,
  BillingIconBlue,
  BrifcaseIcon,
  BrifcaseIconBlue,
  ComplianceIcon,
  ComplianceIconBlue,
  DashboardIconBlue,
  DashboardIconWhite,
  DividerIcon,
  DrawerIcon,
  EarnIcon,
  EarnIconBlue,
  HomeIconblue,
  HomeIconWhite,
  ITINn,
  ITINnBlue,
  InvoiceIcon,
  InvoiceIconBlue,
  NotificationIcon,
  ToolsIcon,
  ToolsIconBlue,
  UserIconBlue,
  UserIconWhite,
  OperatingAgreementIcon,
  OperatingAgreementIconBlue,
  SubscriptionsIcon,
  SubscriptionsIconWhite,
} from "../assets/Icon/headerCicon";
import {
  BookkeepingIcon,
  BppIcon,
  TaxIcon,
} from "../assets/Icon/dashboredIcon";
import { backgroundClip } from "html2canvas/dist/types/css/property-descriptors/background-clip";
import { useSelector } from "react-redux";
import { roleId } from "../utils/StorageUtils";
import { useDispatch } from "react-redux";
import { getDashboradData } from "../stores/incorporation";

// Blue version of TaxIcon
const TaxIconBlue = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="17" cy="17" r="17" fill="#EAF1FA" />
    <g clipPath="url(#clip0_79_175)">
      <path
        d="M19.5 10.3332H11.1667V23.6665H22.8333V13.6665H19.5V10.3332ZM9.5 9.49317C9.5 9.0365 9.8725 8.6665 10.3325 8.6665H20.3333L24.5 12.8332V24.494C24.5008 24.6034 24.48 24.712 24.4388 24.8134C24.3976 24.9148 24.3369 25.007 24.2601 25.085C24.1832 25.1629 24.0918 25.2249 23.991 25.2675C23.8902 25.3101 23.7819 25.3324 23.6725 25.3332H10.3275C10.1086 25.3316 9.89918 25.2441 9.74435 25.0894C9.58951 24.9347 9.50175 24.7254 9.5 24.5065V9.49317ZM17 16.5832C16.4475 16.5832 15.9176 16.3637 15.5269 15.973C15.1362 15.5823 14.9167 15.0524 14.9167 14.4998C14.9167 13.9473 15.1362 13.4174 15.5269 13.0267C15.9176 12.636 16.4475 12.4165 17 12.4165C17.5525 12.4165 18.0824 12.636 18.4731 13.0267C18.8638 13.4174 19.0833 13.9473 19.0833 14.4998C19.0833 15.0524 18.8638 15.5823 18.4731 15.973C18.0824 16.3637 17.5525 16.5832 17 16.5832ZM13.2725 21.1665C13.3735 20.2485 13.8097 19.4001 14.4976 18.7838C15.1854 18.1675 16.0765 17.8267 17 17.8267C17.9235 17.8267 18.8146 18.1675 19.5024 18.7838C20.1903 19.4001 20.6265 20.2485 20.7275 21.1665H13.2725Z"
        fill="#2977CC"
      />
    </g>
    <defs>
      <clipPath id="clip0_79_175">
        <rect width="20" height="20" fill="white" transform="translate(7 7)" />
      </clipPath>
    </defs>
  </svg>
);

const drawerWidth = 258;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })<{
  open?: boolean;
  isMobile?: boolean;
}>(({ theme, open, isMobile }) => ({
  flexGrow: 1,

  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.standard * 2,
  }),

  marginLeft: isMobile
    ? open
      ? `${drawerWidth}px`
      : "0px"
    : `-${drawerWidth}px`,
  variants: [
    {
      props: ({ open }) => open,
      style: {
        transition: theme.transitions.create("margin", {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.standard * 2,
        }),
        marginLeft: 0,
      },
    },
  ],
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
  isMobile?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, isMobile }) => ({
  // transition: theme.transitions.create(["margin", "width"], {
  //   easing: theme.transitions.easing.easeInOut,
  //   duration: theme.transitions.duration.standard * 2,
  // }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        width: !isMobile && `calc(100% - ${drawerWidth}px)`,
        marginLeft: `-${drawerWidth}px`,
        // transition: theme.transitions.create(["margin", "width"], {
        //   easing: theme.transitions.easing.easeInOut,
        //   duration: theme.transitions.duration.standard * 2,
        // }),
      },
    },
  ],
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));
export const Search = styled("div")(({ theme }) => ({
  position: "relative",
  height: "46px",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

export const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    // transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

export default function NewLayout() {
  const location = useLocation();
  const { data } = useSelector((store: any) => store.incorporation);
  const einApp = data?.ein_application;
  const companyStatus = data?.company_formation;

  const { page } = useParams();
  const initialSelectedItem = () => {
    if (page?.includes("itin")) return 2;
    if (page?.includes("subscriptions")) return 4;
    if (page?.includes("dashboard")) return 0;
    if (page?.includes("invoices")) return 3;
    return 1;
  };

  const [selectedItem, setSelectedItem] =
    React.useState<number>(initialSelectedItem);

  const [title, setTitle] = React.useState<string>("Dashboard");
  const [toolsSubmenuOpen, setToolsSubmenuOpen] =
    React.useState<boolean>(false);
  const [showIncorporationSubmenu, setShowIncorporationSubmenu] =
    React.useState(false);
  const [selectedSubmenuItem, setSelectedSubmenuItem] = React.useState<string>(
    window.location.pathname.includes("operating-agreement")
      ? "Operating Agreement"
      : window.location.pathname.includes("bookkeeper")
        ? "Bookkeeper"
        : window.location.pathname.includes("tax-filing")
          ? "Tax Filing"
          : window.location.pathname.includes("bpp")
            ? "BPP"
            : "Invoicing",
  );
  const navigate = useNavigate();

  React.useEffect(() => {
    let newSelectedItem = 0;
    let newTitle = "Dashboard";

    if (window.location.pathname.includes("itin")) {
      newSelectedItem = showIncorporationSubmenu ? 2 : 1;
      newTitle = "ITIN";
      setToolsSubmenuOpen(false);
    } else if (window.location.pathname.includes("subscriptions")) {
      newSelectedItem = showIncorporationSubmenu ? 4 : 3;
      newTitle = "Subscriptions";
      setToolsSubmenuOpen(false);
    } else if (
      window.location.pathname.includes("llc") ||
      window.location.pathname.includes("incorporation")
    ) {
      newSelectedItem = 1;
      newTitle = "Incorporation";
      setToolsSubmenuOpen(false);
    } else if (
      window.location.pathname.includes("Invoicing") ||
      window.location.pathname.includes("operating-agreement") ||
      window.location.pathname.includes("bookkeeper") ||
      window.location.pathname.includes("tools") ||
      window.location.pathname.includes("tax-filing")
    ) {
      if (window.location.pathname.includes("operating-agreement")) {
        newSelectedItem = showIncorporationSubmenu ? 3 : 2;
        newTitle = "Operating Agreement";
        setToolsSubmenuOpen(true);
        setSelectedSubmenuItem("Operating Agreement");
      } else if (window.location.pathname.includes("bookkeeper")) {
        newSelectedItem = showIncorporationSubmenu ? 3 : 2;
        newTitle = "Bookkeeper";
        setToolsSubmenuOpen(true);
        setSelectedSubmenuItem("Bookkeeper");
      } else if (window.location.pathname.includes("tax-filing")) {
        newSelectedItem = showIncorporationSubmenu ? 3 : 2;
        newTitle = "Tax Filing";
        setToolsSubmenuOpen(true);
        setSelectedSubmenuItem("Tax Filing");
      } else if (window.location.pathname.includes("bpp")) {
        newSelectedItem = showIncorporationSubmenu ? 3 : 2;
        newTitle = "BPP";
        setToolsSubmenuOpen(true);
        setSelectedSubmenuItem("BPP");
      } else {
        newSelectedItem = showIncorporationSubmenu ? 3 : 2;
        newTitle = "Invoicing";
        setToolsSubmenuOpen(true);
        setSelectedSubmenuItem("Invoicing");
      }
    } else if (window.location.pathname.includes("incorporation")) {
      newSelectedItem = 3;
      newTitle = "Compliance";
      setToolsSubmenuOpen(false);
    } else if (window.location.pathname.includes("billing")) {
      newSelectedItem = 6;
      newTitle = "Billing";
      setToolsSubmenuOpen(false);
    }

    setSelectedItem(newSelectedItem);
    setTitle(newTitle);
  }, [page, window.location.pathname, showIncorporationSubmenu]);

  /************************************************** User NavBar Items ***********************************************************/

  // const navBaritems = isAdmin ? adminMenuItems : menuItems;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(!isMobile);
  const dispatch = useDispatch();

  const menuItems = React.useMemo(() => {
    const items: any[] = [
      {
        text: "Home",
        activeIcon: <HomeIconblue />,
        icon: <HomeIconWhite />,
        hasSubmenu: false,
        onClick: () => {
          setToolsSubmenuOpen(false);
          navigate("/dashboard");
        },
      },
      // Conditionally include Incorporation based on showIncorporationSubmenu
      ...(showIncorporationSubmenu
        ? [
            {
              text: "Incorporation",
              activeIcon: <BrifcaseIconBlue />,
              icon: <BrifcaseIcon />,
              hasSubmenu: false,
              onClick: () => {
                localStorage.setItem("selectedCard", "company");
                navigate("/incorporation");
              },
            },
          ]
        : []),
      {
        text: "ITIN",
        icon: <ITINn />,
        activeIcon: <ITINnBlue />,
        hasSubmenu: false,
        onClick: () => navigate("/itin"),
      },
      {
        text: "Tools",
        icon: <ToolsIcon />,
        activeIcon: <ToolsIcon />,
        endicon: <DownArrowIconBlue />,
        hasSubmenu: true,
        onClick: () => navigate("/tools/invoices"),
      },
      {
        text: "Subscriptions",
        icon: <SubscriptionsIconWhite />,
        activeIcon: <SubscriptionsIcon />,
        onClick: () => navigate("/subscriptions"),
      },
      {
        text: "Earn $100",
        activeIcon: <EarnIconBlue />,
        icon: <EarnIcon />,
        hasSubmenu: false,
        onClick: () =>
          window.open("https://theitin.com/affiliate-dashboard", "_blank"),
      },
    ];

    return items;
  }, [showIncorporationSubmenu, navigate]);

  const getData = async () => {
    try {
      const result = await dispatch<any>(getDashboradData({}));
      setShowIncorporationSubmenu(result?.payload?.data?.llc_bought);
    } catch (error) {}
  };

  React.useEffect(() => {
    getData();
  }, []);

  const handleItemClick = (index: number, item: string) => {
    if (item === "Intech Technology") {
      setTitle(""); // or setTitle("Default Title") if needed
    } else {
      setTitle(item);
    }
    console.log(index, "index");
    setSelectedItem(index);
    if (isMobile) {
      setOpen(false);
    }
  };

  const handleToolsSubmenuToggle = () => {
    const newSubmenuOpen = !toolsSubmenuOpen;
    setToolsSubmenuOpen(newSubmenuOpen);

    // When opening Tools submenu, automatically set Invoices as active
    if (newSubmenuOpen) {
      setSelectedSubmenuItem("Invoices");
      setTitle("Invoices");
      setSelectedItem(3); // Set Tools as the selected menu item
    }
  };

  const handleSubmenuItemClick = (item: string) => {
    setTitle(item);
    setSelectedSubmenuItem(item);
    if (isMobile) {
      setOpen(false);
    }
    if (item === "Operating Agreement") {
      navigate("/tools/operating-agreement");
    } else if (item === "Bookkeeper") {
      navigate("/tools/bookkeeper");
    } else if (item === "Tax Filing") {
      navigate("/tools/tax-filing");
    } else if (item === "Invoicing") {
      navigate("/tools/invoices");
    } else {
      navigate("/tools/bpp");
    }
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        open={open}
        isMobile={isMobile}
        sx={{ background: "white" }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {!open ? (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={[
                  {
                    mr: 2,
                    color: theme.palette.myCustomColor.dark,
                  },
                  open && { display: "none" },
                ]}
              >
                <MenuIcon />
              </IconButton>
            ) : (
              <IconButton
                onClick={handleDrawerClose}
                sx={{
                  mr: 2,
                  position: "absolute",
                  left: -20,
                  zIndex: 3,
                }}
              >
                {theme.direction === "ltr" ? (
                  <DrawerIcon />
                ) : (
                  <ChevronRightIcon />
                )}
              </IconButton>
            )}
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                color: theme.palette.myCustomColor.dark,
                fontSize: 20,
                fontWeight: 500,
              }}
            >
              {title !== "Home" ? title : "Dashboard"}
            </Typography>
          </Box>
          <Box sx={{ display: { xs: "flex" } }}>
            {/* <Search
              sx={{
                background: "#F6F9FD",
                color: "#6B6B6B",
                borderRadius: "8px",
                "&:hover": {
                  background: "#F6F9FD", // Correct hover styling
                },
              }}
            >
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search here…"
                inputProps={{ "aria-label": "search" }}
              />
            </Search> */}

            {/* <IconButton size="large" aria-label="show 17 new notifications">
              <Badge badgeContent={17} color="error">
                <NotificationIcon />
              </Badge>
            </IconButton> */}

            <BasicPopover />
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            background: theme.palette.myCustomColor.link,
            zIndex: 2,
            // transition: "none",
            // transition: "width 0.6s ease !important",
          },
        }}
        variant={isMobile ? "temporary" : "persistent"}
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              paddingTop: "20px",
              gap: 1,
              width: "100%",
              marginBottom: "20px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  paddingLeft: "20px",
                }}
              >
                <img
                  src={logo}
                  alt=""
                  style={{
                    width: "150px",
                    height: "34px",
                    objectFit: "cover",
                  }}
                />
              </div>

              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={() => setOpen(!open)}
                edge="start"
                sx={[
                  {
                    mr: 2,
                    color: "white",
                  },
                  !isMobile && { display: "none" },
                ]}
              >
                <MenuIcon />
              </IconButton>
            </Box>
            <DividerIcon />
          </Box>
        </DrawerHeader>

        <List>
          {menuItems.map((item, index) => {
            return (
              <React.Fragment key={index}>
                {item.text === "Tools" ? (
                  <Box
                    sx={{
                      backgroundColor:
                        selectedItem === (showIncorporationSubmenu ? 3 : 2)
                          ? "rgba(77, 142, 213, 1)"
                          : "transparent",
                      borderRadius: "8px",
                      margin: "0 15px",
                    }}
                  >
                    <ListItem
                      disablePadding
                      sx={{
                        background: "transparent",
                        color: "white",
                      }}
                      onClick={item.onClick}
                    >
                      <ListItemButton
                        onClick={() => {
                          if (item.text === "Tools") {
                            handleToolsSubmenuToggle();
                          } else {
                            handleItemClick(index, item?.text);
                          }
                        }}
                      >
                        {item?.icon ? (
                          <>
                            <ListItemIcon>
                              {selectedItem == index
                                ? item.activeIcon
                                : item.icon}
                            </ListItemIcon>
                            <ListItemText
                              primary={item.text}
                              sx={{
                                "& .MuiTypography-root": {
                                  margin: 0,
                                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  lineHeight: 1.5,
                                },
                              }}
                            >
                              {item.text}
                            </ListItemText>
                            <ListItemIcon>
                              {item.text === "Tools" ? (
                                <Box
                                  sx={{
                                    transform: toolsSubmenuOpen
                                      ? "rotate(180deg)"
                                      : "rotate(0deg)",
                                    transition: "transform 0.3s ease",
                                  }}
                                >
                                  {item.endicon}
                                </Box>
                              ) : (
                                item.endicon
                              )}
                            </ListItemIcon>
                          </>
                        ) : (
                          <>
                            <ListItemText
                              primary={item.text}
                              sx={{
                                "& .MuiTypography-root": {
                                  margin: 0,
                                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  lineHeight: 1.5,
                                },
                              }}
                            >
                              {item.text}
                            </ListItemText>
                            <ListItemIcon>{item.endicon}</ListItemIcon>
                          </>
                        )}
                      </ListItemButton>
                    </ListItem>

                    {/* Tools Submenu */}
                    {toolsSubmenuOpen && (
                      <Box sx={{ pl: 1, mr: 1, pb: 1 }}>
                        <ListItem disablePadding>
                          <ListItemButton
                            onClick={() => handleSubmenuItemClick("Invoicing")}
                            sx={{
                              background:
                                selectedSubmenuItem === "Invoicing"
                                  ? "#fff"
                                  : "transparent",
                              color:
                                selectedSubmenuItem === "Invoicing"
                                  ? "#2977CC"
                                  : "white",
                              borderRadius: "8px",
                              boxShadow:
                                selectedSubmenuItem === "Invoicing"
                                  ? "0 2px 8px rgba(41,119,204,0.08)"
                                  : "none",
                              fontWeight:
                                selectedSubmenuItem === "Invoicing" ? 700 : 500,
                              "&:hover": {
                                background:
                                  selectedSubmenuItem === "Invoicing"
                                    ? "#fff"
                                    : "rgba(255,255,255,0.1)",
                                color:
                                  selectedSubmenuItem === "Invoicing"
                                    ? "#2977CC"
                                    : "white",
                              },
                            }}
                          >
                            <ListItemIcon>
                              {selectedSubmenuItem === "Invoicing" ? (
                                <InvoiceIconBlue />
                              ) : (
                                <InvoiceIcon />
                              )}
                            </ListItemIcon>
                            <ListItemText
                              primary="Invoicing"
                              sx={{
                                "& .MuiTypography-root": {
                                  margin: 0,
                                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  lineHeight: 1.5,
                                },
                              }}
                            />
                          </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                          <ListItemButton
                            onClick={() =>
                              handleSubmenuItemClick("Operating Agreement")
                            }
                            sx={{
                              background:
                                selectedSubmenuItem === "Operating Agreement"
                                  ? "#fff"
                                  : "transparent",
                              color:
                                selectedSubmenuItem === "Operating Agreement"
                                  ? "#2977CC"
                                  : "white",
                              borderRadius: "8px",
                              boxShadow:
                                selectedSubmenuItem === "Operating Agreement"
                                  ? "0 2px 8px rgba(41,119,204,0.08)"
                                  : "none",
                              fontWeight:
                                selectedSubmenuItem === "Operating Agreement"
                                  ? 700
                                  : 500,
                              "&:hover": {
                                background:
                                  selectedSubmenuItem === "Operating Agreement"
                                    ? "#fff"
                                    : "rgba(255,255,255,0.1)",
                                color:
                                  selectedSubmenuItem === "Operating Agreement"
                                    ? "#2977CC"
                                    : "white",
                              },
                            }}
                          >
                            <ListItemIcon>
                              {selectedSubmenuItem === "Operating Agreement" ? (
                                <OperatingAgreementIconBlue />
                              ) : (
                                <OperatingAgreementIcon />
                              )}
                            </ListItemIcon>
                            <ListItemText
                              primary="Operating Agreement"
                              sx={{
                                "& .MuiTypography-root": {
                                  margin: 0,
                                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  lineHeight: 1.5,
                                },
                              }}
                            />
                          </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                          <ListItemButton
                            onClick={() => handleSubmenuItemClick("Bookkeeper")}
                            sx={{
                              background:
                                selectedSubmenuItem === "Bookkeeper"
                                  ? "#fff"
                                  : "transparent",
                              color:
                                selectedSubmenuItem === "Bookkeeper"
                                  ? "#2977CC"
                                  : "white",
                              borderRadius: "8px",
                              boxShadow:
                                selectedSubmenuItem === "Bookkeeper"
                                  ? "0 2px 8px rgba(41,119,204,0.08)"
                                  : "none",
                              fontWeight:
                                selectedSubmenuItem === "Bookkeeper"
                                  ? 700
                                  : 500,
                              "&:hover": {
                                background:
                                  selectedSubmenuItem === "Bookkeeper"
                                    ? "#fff"
                                    : "rgba(255,255,255,0.1)",
                                color:
                                  selectedSubmenuItem === "Bookkeeper"
                                    ? "#2977CC"
                                    : "white",
                              },
                            }}
                          >
                            <ListItemIcon>
                              {selectedSubmenuItem === "Bookkeeper" ? (
                                <BookkeepingIcon fill="#2977CC" />
                              ) : (
                                <BookkeepingIcon />
                              )}
                            </ListItemIcon>
                            <ListItemText
                              primary="Bookkeeper"
                              sx={{
                                "& .MuiTypography-root": {
                                  margin: 0,
                                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  lineHeight: 1.5,
                                },
                              }}
                            />
                          </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                          <ListItemButton
                            onClick={() => handleSubmenuItemClick("Tax Filing")}
                            sx={{
                              background:
                                selectedSubmenuItem === "Tax Filing"
                                  ? "#fff"
                                  : "transparent",
                              color:
                                selectedSubmenuItem === "Tax Filing"
                                  ? "#2977CC"
                                  : "white",
                              borderRadius: "8px",
                              boxShadow:
                                selectedSubmenuItem === "Tax Filing"
                                  ? "0 2px 8px rgba(41,119,204,0.08)"
                                  : "none",
                              fontWeight:
                                selectedSubmenuItem === "Tax Filing"
                                  ? 700
                                  : 500,
                              "&:hover": {
                                background:
                                  selectedSubmenuItem === "Tax Filing"
                                    ? "#fff"
                                    : "rgba(255,255,255,0.1)",
                                color:
                                  selectedSubmenuItem === "Tax Filing"
                                    ? "#2977CC"
                                    : "white",
                              },
                            }}
                          >
                            <ListItemIcon>
                              {selectedSubmenuItem === "Tax Filing" ? (
                                <OperatingAgreementIconBlue />
                              ) : (
                                <OperatingAgreementIcon />
                              )}
                            </ListItemIcon>
                            <ListItemText
                              primary="Tax Filing"
                              sx={{
                                "& .MuiTypography-root": {
                                  margin: 0,
                                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  lineHeight: 1.5,
                                },
                              }}
                            />
                          </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                          <ListItemButton
                            onClick={() => handleSubmenuItemClick("BPP")}
                            sx={{
                              background:
                                selectedSubmenuItem === "BPP"
                                  ? "#fff"
                                  : "transparent",
                              color:
                                selectedSubmenuItem === "BPP"
                                  ? "#2977CC"
                                  : "white",
                              borderRadius: "8px",
                              boxShadow:
                                selectedSubmenuItem === "BPP"
                                  ? "0 2px 8px rgba(41,119,204,0.08)"
                                  : "none",
                              fontWeight:
                                selectedSubmenuItem === "BPP" ? 700 : 500,
                              "&:hover": {
                                background:
                                  selectedSubmenuItem === "BPP"
                                    ? "#fff"
                                    : "rgba(255,255,255,0.1)",
                                color:
                                  selectedSubmenuItem === "BPP"
                                    ? "#2977CC"
                                    : "white",
                              },
                            }}
                          >
                            <ListItemIcon>
                              {selectedSubmenuItem === "BPP" ? (
                                <BppIcon />
                              ) : (
                                <BppIcon fill="#ffffff" />
                              )}
                            </ListItemIcon>
                            <ListItemText
                              primary="BPP"
                              sx={{
                                "& .MuiTypography-root": {
                                  margin: 0,
                                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  lineHeight: 1.5,
                                },
                              }}
                            />
                          </ListItemButton>
                        </ListItem>
                      </Box>
                    )}
                  </Box>
                ) : (
                  <ListItem
                    disablePadding
                    sx={{
                      ...(item?.text === "Intech Technology"
                        ? {
                            background: "#4D8ED5",
                            borderRadius: "5px",
                            fontWeight: 600,
                            fontSize: "14px !important",
                            color: "#ffffff",
                            marginBottom: "8px",
                          }
                        : {
                            background:
                              selectedItem == index &&
                              item.text !== "Main Menu" &&
                              item.text !== "Tools"
                                ? "white"
                                : "tranparent",
                            color:
                              selectedItem == index &&
                              item.text !== "Main Menu" &&
                              item.text !== "Tools"
                                ? "#2977CC"
                                : "white",
                          }),
                    }}
                    onClick={item.onClick}
                  >
                    <ListItemButton
                      onClick={() => {
                        if (item.text === "Tools") {
                          handleToolsSubmenuToggle();
                        } else {
                          handleItemClick(index, item?.text);
                        }
                      }}
                    >
                      {item?.icon ? (
                        <>
                          <ListItemIcon>
                            {selectedItem == index
                              ? item.activeIcon
                              : item.icon}
                          </ListItemIcon>
                          <ListItemText
                            primary={item.text}
                            sx={{
                              "& .MuiTypography-root": {
                                margin: 0,
                                fontFamily: "'Plus Jakarta Sans', sans-serif",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: 1.5,
                              },
                            }}
                          >
                            {item.text}
                          </ListItemText>
                          <ListItemIcon>
                            {item.text === "Tools" ? (
                              <Box
                                sx={{
                                  transform: toolsSubmenuOpen
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                                  transition: "transform 0.3s ease",
                                }}
                              >
                                {item.endicon}
                              </Box>
                            ) : (
                              item.endicon
                            )}
                          </ListItemIcon>
                        </>
                      ) : (
                        <>
                          <ListItemText
                            primary={item.text}
                            sx={{
                              "& .MuiTypography-root": {
                                margin: 0,
                                fontFamily: "'Plus Jakarta Sans', sans-serif",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: 1.5,
                              },
                            }}
                          >
                            {item.text}
                          </ListItemText>
                          <ListItemIcon>{item.endicon}</ListItemIcon>
                        </>
                      )}
                    </ListItemButton>
                  </ListItem>
                )}
              </React.Fragment>
            );
          })}
        </List>
      </Drawer>

      <Main
        open={open}
        isMobile={isMobile}
        sx={{
          background: "#F6F9FD",
          width: isMobile ? "100vw" : "calc(100vw - 258px)", // Fixes layout on mobile
          overflow: "auto",
          height:
            /\/incorporation\/[\w-]+(\/(edit|view))?$/.test(
              window.location.pathname,
            ) ||
            /\/single-member/.test(window.location.pathname) ||
            /\/multimember/.test(window.location.pathname) ||
            /\/corp-member/.test(window.location.pathname)
              ? "auto"
              : "calc(100vh - 10px)",
        }}
      >
        <DrawerHeader />
        {/* <Container> */}
        <Outlet />
      </Main>
      {/* </Container> */}
    </Box>
  );
}
